import Fuse from "fuse.js";

export const searchHelper = (data, keyFields, keyword) => {
  const fuse = new Fuse(data, { keys: keyFields });
  const searchResults = fuse.search(keyword);

  const results = searchResults.map((res) => res.item);
  return { data: results, count: results.length, total: results.length };
};
